/* =====================================================
   Adele Chérie — Animations engine v2
   2026-05-14 · Webflow-style dynamic motion
   ===================================================== */

(function() {
  'use strict';

  if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') return;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) return;

  if (window.__acAnimationsInitialized) return;
  window.__acAnimationsInitialized = true;

  // Progressive enhancement flag: solo se questa classe e presente,
  // il CSS applica gli stati iniziali invisibili in attesa dell animation.
  document.documentElement.classList.add('ac-js-ready');

  function init() {
    initScrollAnimations();
    initParallax();
    initMagnetic();
    initStickyStepper();
    initCounters();
  }

  // ============================================
  // 1. Scroll-triggered animations
  // ============================================
  function initScrollAnimations() {
    var selectors = '.ac-fade-up, .ac-fade-in, .ac-image-reveal, .ac-stagger, .ac-clip-reveal, .ac-rise';
    var elements = document.querySelectorAll(selectors);
    if (!elements.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ac-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    elements.forEach(function(el) { observer.observe(el); });
  }

  // ============================================
  // 2. Parallax — multiplo, ottimizzato con rAF
  // ============================================
  function initParallax() {
    var parallaxEls = document.querySelectorAll('.ac-parallax');
    if (!parallaxEls.length) return;

    var ticking = false;
    var prepared = [];

    parallaxEls.forEach(function(el) {
      prepared.push({
        el: el,
        rate: parseFloat(el.getAttribute('data-parallax-rate') || '0.3')
      });
    });

    function update() {
      var y = window.pageYOffset;
      prepared.forEach(function(p) {
        var rect = p.el.getBoundingClientRect();
        // Solo se in viewport (con buffer)
        if (rect.bottom > -200 && rect.top < window.innerHeight + 200) {
          var sectionY = rect.top + y;
          var relativeY = (y - sectionY) * p.rate;
          p.el.style.transform = 'translate3d(0, ' + relativeY + 'px, 0)';
        }
      });
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update(); // initial position
  }

  // ============================================
  // 3. Magnetic buttons — segue il cursore
  // ============================================
  function initMagnetic() {
    var magneticEls = document.querySelectorAll('.ac-magnetic');
    if (!magneticEls.length) return;

    magneticEls.forEach(function(el) {
      var rect, x, y, strength = 0.3;

      el.addEventListener('mouseenter', function() {
        rect = el.getBoundingClientRect();
      });

      el.addEventListener('mousemove', function(e) {
        if (!rect) rect = el.getBoundingClientRect();
        x = e.clientX - rect.left - rect.width / 2;
        y = e.clientY - rect.top - rect.height / 2;
        el.style.transform = 'translate(' + (x * strength) + 'px, ' + (y * strength) + 'px)';
      });

      el.addEventListener('mouseleave', function() {
        el.style.transform = '';
      });
    });
  }

  // ============================================
  // 4. Sticky stepper — i step si "fissano" mentre scrolli
  // ============================================
  function initStickyStepper() {
    var stepper = document.querySelector('.ac-gesto__steps');
    if (!stepper) return;

    var steps = stepper.querySelectorAll('.ac-gesto__step');
    if (!steps.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ac-step-active');
        } else {
          entry.target.classList.remove('ac-step-active');
        }
      });
    }, { threshold: 0.6 });

    steps.forEach(function(step) { observer.observe(step); });
  }

  // ============================================
  // 5. Number counters — animazione di conteggio
  // ============================================
  function initCounters() {
    var counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.6 });

    counters.forEach(function(el) { observer.observe(el); });
  }

  function animateCounter(el) {
    var target = parseFloat(el.getAttribute('data-counter')) || 0;
    var duration = parseInt(el.getAttribute('data-counter-duration') || '1800', 10);
    var suffix = el.getAttribute('data-counter-suffix') || '';
    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      // ease out
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(target * eased);
      el.textContent = current + suffix;
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = target + suffix;
      }
    }

    window.requestAnimationFrame(step);
  }

  // ============================================
  // BOOT
  // ============================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
